module.exports = __webpack_public_path__ + "img/slack-hash.f750263e.svg";